import { Component, OnInit } from '@angular/core';

import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { Prestador } from '../shared/model/prestador.model';
import { Pageable } from '../shared/model/pageable.model';
import { PrestadorService } from './prestador.service';
import { TipoEspecialidade } from '../shared/model/tipo-especialidade.model';
import { ToastrService } from 'ngx-toastr';

@Component({templateUrl: './prestador.component.html', styleUrls: ['./prestador.component.css']})
export class PrestadorComponent implements OnInit {

  prestador: Prestador;
  listaPrestadores: Prestador[];
  listaEspecialidades: TipoEspecialidade[];

  valueFilter = '';
  pageable: Pageable;

  labels: any = { previousLabel: '', nextLabel: '' };

  constructor(config: NgbModalConfig, private modalService: NgbModal, private prestadorService: PrestadorService,
    private toast: ToastrService) {
      // customizar os valores default do modal.
      config.backdrop = 'static';
      config.keyboard = false;
  }

  ngOnInit(): void {
    // Inicializando o pageable com valores padrões.
    this.pageable = new Pageable();
    this.getPrestadores();
    this.listarEspecialidades();
  }

  pageChanged(event) {
    this.pageable.page = event;
    this.getPrestadores();
  }

  // Método responsável pelo filtro da table.
  buscarPrestadores() {
    this.pageable.page = 1;
    this.getPrestadores();
  }

  // Método responsável por buscar a lista de prestadores.
  private getPrestadores() {
    this.prestadorService.listarPrestadores(this.pageable, this.valueFilter).subscribe(
      (dados) =>  {
        this.pageable.totalElements = dados.totalElements;
        this.listaPrestadores = dados.content;
      },
      errorResponse => this.toast.error(errorResponse.error.mensagemUsuario)
    );
  }

  listarEspecialidades() {
    this.prestadorService.listarEspecialidades().subscribe(
      dados => this.listaEspecialidades = dados,
      responseError => this.toast.error('Error ao processar requisição')
    );
  }

  // Método para inativar o cadastro de um prestador.
  inativarPrestador(prestadorId: number) {
    this.prestadorService.inativar(prestadorId).subscribe(
      () => {
        this.toast.success('Prestador inativado com sucesso!');
        this.getPrestadores();
      },
      (responseError) => this.toast.error('Erro ao inativar prestador, tente novamente!')
    );
  }

  // Método para ativar o cadastro de um prestador.
  ativarPrestador(prestadorId: number) {
    this.prestadorService.ativar(prestadorId).subscribe(
      () => {
        this.toast.success('Prestador ativado com sucesso!');
        this.getPrestadores();
      },
      (responseError) => this.toast.error('Erro ao ativar prestador, tente novamente!')
    );
  }

  // Método responsável por preparar o modal para cadastrar um novo prestador
  novoPrestador(content) {
    // Inicializar o objeto toda vez que o modal for chamado
    this.prestador = new Prestador();

    // Abrir o modal
    this.modalService.open(content);
  }

  // Método responsável para preparar o modal para alteração
  alterarPrestador(content, prestadorId: number) {
    this.prestadorService.buscar(prestadorId).subscribe(
        (prestador) => {
          this.prestador = prestador;

          // TODO: Validar outra forma de setar o objeto tipoEspecialidade para o select.
          this.prestador.tipoEspecialidade = prestador.tipoEspecialidade.id;

          this.modalService.open(content);
        },
        (errror) => this.toast.error('Erro ao carregar prestador, tente novamente!')
    );
  }

  // Método usado para cadastrar/alterar um procedimento
  save(form) {
    if (this.prestador.id) {
        this.prestadorService.alterar(this.prestador).subscribe(
          () => {
            this.toast.success('Prestador alterado com sucesso!');

            this.getPrestadores();
          },
          (responseError) => this.toast.error('Erro ao alterar o prestador, tente novamente!')
        );
    } else {
      this.prestadorService.cadastrar(this.prestador).subscribe(
        () => {
          this.toast.success('Procedimento cadastrado com sucesso!');

          this.pageable.page = 1;
          this.getPrestadores();

          // Resetar o form após confirmar
          form.reset();

          // Inicializar o objeto toda vez que for alterado.
          this.prestador = new Prestador();
        },
        (responseError) => this.toast.error('Erro ao cadastrar o prestador, tente novamente!')
      );
    }
  }
}
